<template>
    <div>
        <div class="catalog-page page my-container" v-if="route.params.type === 'category'">
            <h1 class="header">
                {{ t('productCatalog') }}
            </h1>
            <div class="category-list">
                <NuxtLink class="category" v-for="cat in entries" :key="cat.id"
                    :to="localePath(`/catalog/${route.params.type}/` + cat.id)">
                    <div class="img-wrapper">
                        <img :src="cat.image[locale]" :alt="cat.name[locale]">
                        <div class="overlay"></div>
                    </div>
                    <span class="name">
                        {{ cat.name[locale] }}
                    </span>
                </NuxtLink>
            </div>
        </div>
        <div class="series-page page my-container" v-if="route.params.type === 'series'">
            <h1 class="header">
                {{ t('ourSeries') }}
            </h1>

            <div class="series-list">
                <NuxtLink :to="localePath(`/catalog/${route.params.type}/` + ser.id)" class="entry"
                    v-for="(ser, i) in entries" :key="ser.id">
                    <div class="overlay"
                        :style="'background:' + `url('${ser.banner[locale]}') no-repeat center center/cover;`">
                    </div>
                    <span>{{ ser.name }}</span>
                </NuxtLink>
            </div>
        </div>
        <div class="brand-list page my-container" v-if="route.params.type === 'brand'">
            <h1 class="header">
                {{ t('ourBrands2') }}
            </h1>
            <div class="brand-wrapper">
                <NuxtLink class="brand" v-for="cat in entries" :key="cat.id"
                    :to="localePath(`/catalog/${route.params.type}/` + cat.id)">
                    <div class="img-wrapper">
                        <img :src="cat.image" :alt="cat.name[locale]">
                        <div class="overlay"></div>
                    </div>
                    <span class="name">
                        {{ cat.name }}
                    </span>
                </NuxtLink>
            </div>
        </div>
    </div>
</template>

<script setup>
const { locale, t } = useI18n()
const localePath = useLocalePath()
const rc = useRuntimeConfig();
const route = useRoute()
const res = await $fetch(rc.public.api + `/api/${route.params.type}/`);
const entries = ref(res.data.list)
</script>